const {COUNTRIES} = require('../app/AppConstant');
const MAX_ZIP_LEN = 12,
    MAX_CITY_LEN = 40,
    MAX_TEXT_LEN = 100;

class Address {

    constructor({
                    type = Address.ADDRESS_TYPE.PERSON,
                    fullName = '',
                    addressLine1 = '',
                    addressLine2 = '',
                    street = '',
                    city = '',
                    zip = '',
                    country = COUNTRIES["DE"].code,
                } = {}) {

        this._type = Address.ADDRESS_TYPE.PERSON;
        this._fullName = fullName;
        this._addressLine1 = addressLine1;
        this._addressLine2 = addressLine2;
        this._street = street;
        this._city = city;
        this._zip = zip;
        this._country = COUNTRIES[country] ? country : null;
        this._type = type;
        this._country = country;


    }


    get type() {
        return this._type;
    }

    set type(value) {
        if (Address.ADDRESS_TYPE[value]) {
            this._type = value;
        }
    }

    get fullName() {
        return this._fullName;
    }

    set fullName(value) {
        value = value || ''
        if (value.length < MAX_TEXT_LEN) {
            this._fullName = value;
        }
    }

    get addressLine1() {
        return this._addressLine1;
    }

    set addressLine1(value) {
        value = value || ''
        if (value.length < MAX_TEXT_LEN) {
            this._addressLine1 = value;
        }
    }

    get addressLine2() {
        return this._addressLine2;
    }

    set addressLine2(value) {
        value = value || ''
        if (value.length < MAX_TEXT_LEN) {
            this._addressLine2 = value;
        }
    }

    get street() {
        return this._street;
    }

    set street(value) {
        value = value || ''
        if (value.length < MAX_TEXT_LEN) {
            this._street = value;
        }
    }

    get city() {
        return this._city;
    }

    set city(value) {
        value = value || ''
        if (value.length < MAX_CITY_LEN) {
            this._city = value;
        }
    }

    get zip() {
        return this._zip;
    }

    set zip(value) {
        value = value || ''
        if (value.length < MAX_ZIP_LEN) {
            this._zip = value;
        }
    }

    get country() {
        return this._country;
    }

    set country(value) {
        if (COUNTRIES[value]) {
            this._country = value;
        }
    }

    static get ADDRESS_TYPE() {
        return {
            PERSON: 'PERSON',
            COMPANY: 'COMPANY',
            INVOICE: 'INVOICE',
            DELIVERY: 'DELIVERY',
        }
    }

    validate(attribute) {

        if (attribute === undefined) {
            const attributes = Object.keys(this);

            try {
                attributes.map(attribute => {
                    if (!this._validate(attribute)) {
                        throw "validation error"
                    }
                });
            } catch (e) {
                return false
            }

            return true
        }

        return this._validate(attribute)
    }

    _validate(attribute) {

        try {
            switch (attribute.replace('_', '')) {
                case 'type':
                    return Object.values(Address.ADDRESS_TYPE).includes(this[attribute]);
                case 'zip':
                    return (typeof this[attribute] === 'string')
                        && (this[attribute].length !== 0)
                        && (this[attribute].length <= MAX_ZIP_LEN);
                case 'addressLine1':
                case 'addressLine2':
                    return (typeof this[attribute] === 'string')
                        && (this[attribute].length <= MAX_TEXT_LEN);
                case 'fullName':
                case 'street':
                    return (typeof this[attribute] === 'string')
                        && (this[attribute].length !== 0)
                        && (this[attribute].length <= MAX_TEXT_LEN);
                case 'city':
                    return (typeof this[attribute] === 'string')
                        && (this[attribute].length !== 0)
                        && (this[attribute].length <= MAX_CITY_LEN);
                case 'country':
                    return Object.keys(COUNTRIES).includes(this[attribute]);
                default:
                    return false
            }
        } catch (e) {
            console.error('Validating address with error:', e, attribute);
            return false
        }
    }

    static parseFirestore(address, key = '') {
        return new Address({
            ...address
        })
    }

    toFirestore() {
        return {
            type: this._type,
            fullName: this._fullName,
            addressLine1: this._addressLine1,
            addressLine2: this._addressLine2,
            street: this._street,
            city: this._city,
            zip: this._zip,
            country: this._country
        }
    }
}

module.exports = Address;